import React from 'react';
import { Link } from 'react-router-dom';
import Header from './layout/Header';
import Footer from './layout/Footer';

export default function NotFound() {
  return (
    <React.Fragment>
      <Header />
      <main 
        style={{
          minHeight: 'calc(100vh - 250px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 'linear-gradient(180deg, #EEFFFD 0%, #FFFFFF 100%)',
          padding: '80px 20px',
          position: 'relative',
          overflow: 'hidden',
          fontFamily: 'var(--heading-font-family)'
        }}
      >
        {/* Decorative background blobs */}
        <div 
          style={{
            position: 'absolute',
            width: '350px',
            height: '350px',
            background: 'rgba(0, 128, 128, 0.08)',
            borderRadius: '50%',
            filter: 'blur(80px)',
            top: '-50px',
            left: '-50px',
            zIndex: 1
          }}
        />
        <div 
          style={{
            position: 'absolute',
            width: '400px',
            height: '400px',
            background: 'rgba(0, 29, 61, 0.05)',
            borderRadius: '50%',
            filter: 'blur(100px)',
            bottom: '-100px',
            right: '-100px',
            zIndex: 1
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row justify-content-center">
            <div className="col-lg-7 col-md-9 text-center">
              {/* Floating 404 Illustration */}
              <div 
                style={{
                  fontSize: 'clamp(100px, 12vw, 160px)',
                  fontWeight: '800',
                  lineHeight: '1',
                  background: 'linear-gradient(135deg, #008080 0%, #001D3D 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  margin: '0 auto 20px',
                  letterSpacing: '-2px',
                  animation: 'float 6s ease-in-out infinite',
                  filter: 'drop-shadow(0px 10px 20px rgba(0, 128, 128, 0.15))'
                }}
              >
                404
              </div>

              {/* Styled Keyframe Animation in JSX */}
              <style>{`
                @keyframes float {
                  0% { transform: translateY(0px); }
                  50% { transform: translateY(-10px); }
                  100% { transform: translateY(0px); }
                }
                .btn-home {
                  background: #008080;
                  color: #ffffff !important;
                  border: 2px solid #008080;
                  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                  box-shadow: 0 4px 14px rgba(0, 128, 128, 0.25);
                }
                .btn-home:hover {
                  background: #006666;
                  border-color: #006666;
                  transform: translateY(-2px);
                  box-shadow: 0 6px 20px rgba(0, 128, 128, 0.35);
                }
                .btn-contact {
                  background: transparent;
                  color: #001D3D !important;
                  border: 2px solid #001D3D;
                  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                }
                .btn-contact:hover {
                  background: #001D3D;
                  color: #ffffff !important;
                  transform: translateY(-2px);
                  box-shadow: 0 6px 20px rgba(0, 29, 61, 0.15);
                }
              `}</style>

              <h2 
                style={{
                  fontSize: 'clamp(24px, 4vw, 32px)',
                  fontWeight: '700',
                  color: '#001D3D',
                  marginBottom: '15px'
                }}
              >
                Oops! Page Not Found
              </h2>
              
              <p 
                style={{
                  fontSize: 'clamp(15px, 2vw, 17px)',
                  color: '#62748E',
                  lineHeight: '1.6',
                  maxWidth: '520px',
                  margin: '0 auto 35px'
                }}
              >
                The page you are looking for might have been removed, had its name changed, or is temporarily unavailable. Let's get you back on track!
              </p>

              <div className="d-flex flex-wrap justify-content-center gap-3">
                <Link 
                  to="/" 
                  className="btn btn-home px-4 py-2.5 fw-semibold d-inline-flex align-items-center justify-content-center"
                  style={{ borderRadius: '50px', fontSize: '15px' }}
                >
                  <i className="fa fa-home me-2"></i> Back to Homepage
                </Link>
                <Link 
                  to="/contact-us" 
                  className="btn btn-contact px-4 py-2.5 fw-semibold d-inline-flex align-items-center justify-content-center"
                  style={{ borderRadius: '50px', fontSize: '15px' }}
                >
                  Contact Support
                </Link>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </React.Fragment>
  );
}
